import type { Site } from '@hotjar/webapp/domains/common/feature';
import { useCurrentSite } from '@hotjar/site';
import { isAllowedForAsk } from './feature';

/**
 * Looks for a given feature on ono either the current Ask plan
 * (or general plan if Ask plan is not present), site, organization, or account.
 * Passing in an optional site will use that site rather then the currently active site.
 *
 * Usage:
 * const hasBrandingToggleFeature = useAskFeature('branding.toggle', siteObject);
 *
 * @param {string} feature Name of the feature flag to lookup.
 * @param {object} [site] An optional site object to look for the feature in.
 * @deprecated use useFeatureFlag, useGate or useLimit instead
 */
export function useAskFeature(feature: string, site?: Site): boolean {
  const { data: currentSite } = useCurrentSite();

  if (!site && !currentSite) {
    return false;
  }

  if (site) {
    return isAllowedForAsk(feature, site);
  }

  return isAllowedForAsk(feature, currentSite ?? null);
}
